const notificationHub = {
  loadMore: "Load More",
  notifications: {
    updates: "Updates",
  },
};

export { notificationHub };
